module.exports = __webpack_public_path__ + "static/img/about_1bg2.61d305d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_1bg2.jpg
// module id = tu+t
// module chunks = 1